module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow@3-88e29acd48870cc9ea95463636ad0d5f.png";